/**
 * One colour per device type, shared by the 3D scene and the logical view so
 * a router reads the same everywhere. Values are semantic token names
 * (`var(--<token>)`), never hex, so they follow light/dark and brand themes.
 *
 * Chosen for separation at a glance: active gear in saturated hues (router
 * blue, switch green, security red, compute purple), passive gear muted
 * (patch panels grey) except fiber, which matches the fiber link colour.
 */
export const KIND_TOKEN: Record<string, string> = {
  router: 'info',
  switch: 'success',
  firewall: 'notification',
  gateway: 'notification',
  patch_panel: 'text-muted',
  fiber: 'accent-orange',
  server: 'accent-purple',
  shelf: 'accent-purple',
  ups: 'warning',
  pdu: 'warning',
  phone_system: 'accent-gold',
  kvm: 'text-faint',
  other: 'text-faint',
};

export function kindToken(kind: string): string {
  return KIND_TOKEN[kind] ?? 'text-faint';
}

export function kindColor(kind: string): string {
  return `var(--${kindToken(kind)})`;
}

/** Legend rows, in the order a rack reads: routing → switching → security → compute → passive → power. */
export const KIND_LEGEND: { label: string; kind: string }[] = [
  { label: 'Router', kind: 'router' },
  { label: 'Switch', kind: 'switch' },
  { label: 'Firewall / gateway', kind: 'firewall' },
  { label: 'Server', kind: 'server' },
  { label: 'Patch panel', kind: 'patch_panel' },
  { label: 'Fiber', kind: 'fiber' },
  { label: 'Power', kind: 'ups' },
  { label: 'Telephony', kind: 'phone_system' },
];
